import { Component, Input, ViewChild } from '@angular/core';
import { MenuItem, MessageService } from 'primeng/api';
import { TranslocoService } from '@jsverse/transloco';
import { PaymentMethodTokenInfo } from '../../../core/models/corporate/payment-method-token.model';
import { CorporateService } from '../../../core/services/corporate.service';
import { ADD_METHOD_PAYMENT_BUTTON, EDIT_ACTION_CIRCLE, REMOVE_ACTION } from '../../constants/common-bt';
import { StripePaymentComponent } from '../stripe-payment/stripe-payment.component';

@Component({
  selector: 'app-payment-method',
  standalone: false,
  templateUrl: './payment-method.component.html',
  styleUrl: './payment-method.component.scss'
})
export class PaymentMethodComponent {

  cardActions = { EDIT_ACTION_CIRCLE, REMOVE_ACTION, ADD_METHOD_PAYMENT_BUTTON };
  @Input() currentMethodPayment: PaymentMethodTokenInfo | null = null;
  @Input() openDirect = false;
  @ViewChild('stripePayment') stripePaymentComponent!: StripePaymentComponent;
  items: MenuItem[] = [];

  constructor(
    private corporateService: CorporateService,
    private messageService: MessageService,
    private transloco: TranslocoService
  ) {
    this.items = [
      {
        items: [
          {
            label: this.transloco.translate('payment.changePaymentMethod'),
            styleClass: 'secondary-btn',
            command: () => {
              this.openPaymentMethodDialog();
            }
          }
        ]
      }
    ];
  }

  /** Stripe entrega la marca ya identificada; solo hay que mapear su nombre
   *  al del archivo de icono que tenemos. */
  getCardBrand(brand: string | undefined): string {
    switch ((brand ?? '').toLowerCase()) {
      case 'visa': return 'visa';
      case 'mastercard': return 'mastercard';
      case 'amex':
      case 'american_express': return 'american-express';
      case 'discover': return 'discover';
      default: return 'default';
    }
  }

  getCardTypeLabel(brand: string | undefined): string {
    switch (this.getCardBrand(brand)) {
      case 'visa': return 'Visa';
      case 'mastercard': return 'MasterCard';
      case 'american-express': return 'American Express';
      case 'discover': return 'Discover';
      default: return this.transloco.translate('payment.unknownCard');
    }
  }

  formatCardNumber(last4: string | undefined): string {
    if (!last4) return '';
    return '•••• •••• •••• ' + last4;
  }

  openPaymentMethodDialog(): void {
    // SetupIntent de Stripe: guarda la tarjeta sin cobrar nada, y queda lista
    // para los cobros posteriores de citas corporativas.
    this.corporateService.createStripeSetupIntent().subscribe({
      next: ({ clientSecret }) => {
        void this.stripePaymentComponent.showStripeForm(clientSecret);
      },
      error: error => {
        // Antes esto solo hacía console.error: el usuario pulsaba el botón y
        // no pasaba absolutamente nada visible.
        console.error('Error creating Stripe setup intent:', error);
        this.messageService.add({
          severity: 'error',
          summary: this.transloco.translate('common.error'),
          detail: this.transloco.translate('payment.methodAddFailed'),
        });
      }
    });
  }
  completeAddMethodPayment($event: boolean) {
    if ($event) {
      this.messageService.add({ severity: 'success', summary: this.transloco.translate('common.success'), detail: this.transloco.translate('payment.methodAddedSuccess') });
      this.corporateService.loadPaymentMethodToken().subscribe();
    } else {
      this.messageService.add({ severity: 'error', summary: this.transloco.translate('common.error'), detail: this.transloco.translate('payment.methodAddFailed') });
    }
  }
}
